export default __webpack_public_path__ + "static/media/Poweredby_640px-White_VertText.800c119a.png";